module.exports = __webpack_public_path__ + "static/img/adC2.358c8d5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/adC2.jpeg
// module id = mNEV
// module chunks = 26